import { Link } from "react-router-dom";

export default function Footer({ note }: { note?: React.ReactNode }) {
  return (
    <footer className="mt-10 border-t border-slate-800 pt-4 text-center text-[11px] text-slate-500">
      {note ? <div className="mb-2 text-slate-600">{note}</div> : null}
      <div>
        <span className="text-amber-400/80">Not financial advice.</span>{" "}
        AI-generated output from public data — may be wrong or delayed.{" "}
        <Link to="/legal" className="underline-offset-2 hover:text-slate-300 hover:underline">
          Disclaimer
        </Link>
      </div>
    </footer>
  );
}
